import { render, staticRenderFns } from "./CardRealEstateGroup.vue?vue&type=template&id=68870546&scoped=true"
import script from "./CardRealEstateGroup.vue?vue&type=script&lang=js"
export * from "./CardRealEstateGroup.vue?vue&type=script&lang=js"
import style0 from "./CardRealEstateGroup.vue?vue&type=style&index=0&id=68870546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68870546",
  null
  
)

export default component.exports